import React from 'react'

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material'
import { useCustomerRoles } from 'features/customers/hooks/useCustomerRoles'
import { useParams } from 'react-router'

import { FormSelect } from 'components/input'
import { withForm } from 'decorators/withForm'

type CustomerUserEditModalProps = {
  handleSubmit: (...args: any[]) => any
  onClose: (...args: any[]) => any
  onSubmit: (...args: any[]) => any
}

const CustomerUserEditModal = ({ handleSubmit, onSubmit, onClose }: CustomerUserEditModalProps) => {
  const { id: customerId } = useParams<{ id: string }>()
  const { data } = useCustomerRoles(customerId)

  // roleId is stored/submitted as a string, so keep the option value a string to preserve selected-matching and wire type.
  const roles = (data || []).map((role: any) => ({ value: role.id.toString(), label: role.name }))

  const jobDepartmentOptions = Object.entries({
    FINANCE: 'Finance',
    MARKETING: 'Marketing',
    OPERATIONS: 'Operations',
    OTHER: 'Other',
    SALES: 'Sales',
    TECHNOLOGY: 'Technology',
  }).map(([value, label]) => ({ value, label }))

  const jobTitleOptions = Object.entries({
    CONSULTANT: 'Consultant',
    EMPLOYEE: 'Employee',
    EXECUTIVE: 'Executive',
    MANAGER: 'Manager',
    OTHER: 'Other',
    WEBMASTER: 'Webmaster',
  }).map(([value, label]) => ({ value, label }))

  return (
    <Dialog onClose={onClose} open>
      <form onSubmit={handleSubmit(onSubmit)} style={{ width: 500 }}>
        <DialogTitle>Customer user edit</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid
              size={{
                sm: 12,
              }}>
              <FormSelect label="Job department" name="jobDepartment" options={jobDepartmentOptions} />
            </Grid>

            <Grid
              size={{
                sm: 12,
              }}>
              <FormSelect label="Job title" name="jobTitle" options={jobTitleOptions} />
            </Grid>

            <Grid
              size={{
                sm: 12,
              }}>
              <FormSelect allowEmpty={false} label="Role" name="roleId" options={roles} />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="submit">Confirm</Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default withForm({ form: 'customerUserEdit' })(CustomerUserEditModal)
